import { ReactNode, CSSProperties } from 'react';
import { UploadFile, UploadProps } from 'antd/lib/upload/interface';
import { RenderDOMFunc } from '../constants/interface';

/** 上传类型 */
export type uploadType = 'aliyun' | 'minio';
export type uploadSize = "large" | "middle" | "small" | "default" | "auto";
/** 服务端返回数据 */
export interface OSSDataConfig {
  /** 上传类型 */
  type: uploadType;
  /** 发送上传请求的域名 */
  host: string;
  /** 图片访问域名 */
  endpoint: string;
  /** 限制上传的文件前缀 */
  dir: string;
  /** 有效时间（毫秒） */
  effectiveTime: number;
  /** 由服务器端指定的Policy过期时间，格式为Unix时间戳（秒) */
  expire: number;
  /** 可上传的文件类型 */
  accept?: string;
  /** 表单上传的策略 */
  policy?: string;
  /** AccessKey ID */
  accessid?: string;
  /** 对Policy签名后的字符串 */
  signature?: string;
}
/** 上传文件基础参数 */
export interface UploadBaseProps extends Omit<UploadProps, 'onChange'> {
  /** 场景 */
  scene?: string;
  /** 类名 */
  size?: uploadSize;
  /** 上传按钮文字 */
  uploadText?: ReactNode;
  /** 上传按钮icon */
  uploadIcon?: ReactNode;
  /** 菜单渲染父节点。默认渲染到 body 上 */
  getPopupContainer?: RenderDOMFunc;
  /** 文件列表发生改变时回调 */
  onChange?: (fileList?: UploadFile<any> | UploadFile<any>[]) => void;
  /** 重置 */
  onReset?: () => Promise<any>;
}
/** 阿里云oss上传额外参数 */
export interface AliyunBaseProps {
  /** 请求服务端返回数据 */
  OSSData: OSSDataConfig;
}
/** minio上传额外参数 */
export interface MinioBaseProps {
  /** minio上传路径 */
  uploadUrl?: string;
}
/** 上传单张图片基础参数 */
export interface UploadImageBaseProps {
  /** 大小 */
  size?: uploadSize;
  /** 自定义样式 */
  style?: CSSProperties;
  /** 自定义最外层容器类名 */
  wrapperClassName?: string;
  /** 是否隐藏图片 */
  hideImage?: boolean;
}
/** 上传文件基础参数 */
export interface UploadFileBaseProps {
  /** 上传完成回调 */
  onComplete?: (res: any) => void;
}
/** ali上传多张图片 */
export type AliyunUploadImagesProps = UploadBaseProps & AliyunBaseProps;
/** minio上传多张图片 */
export type MinioUploadImagesProps = UploadBaseProps & MinioBaseProps;
/** ali上传多张图片 */
export type AliyunUploadImageProps = UploadBaseProps &
  AliyunBaseProps &
  UploadImageBaseProps;
/** minio上传多张图片 */
export type MinioUploadImageProps = UploadBaseProps &
  MinioBaseProps &
  UploadImageBaseProps;
/** ali上传多张图片 */
export type AliyunUploadFileProps = UploadBaseProps &
  AliyunBaseProps &
  UploadFileBaseProps;
/** minio上传多张图片 */
export type MinioUploadFileProps = UploadBaseProps &
  MinioBaseProps &
  UploadFileBaseProps;
/** 阿里云oss临近过期时间（毫秒） */
export const EXPIRE_TIME: number = 60000;
/** 阿里与oss key 有效时间 （毫秒） */
export const EXPIRE_EFFECTIVE_TIME: number = 300000;
